import { ChainId } from '@/lib/chain'
import { TEnvConfig } from './env.interfact'
import { PROD_CONFIG } from './prod'

export const BETA_CONFIG: TEnvConfig = {
  ...PROD_CONFIG,
  amplitudeApiKey: process.env.REACT_APP_AMPLITUDE_API_KEY ?? '',
  supportedChains: [
    ChainId.ETHEREUM,
    ChainId.OPTIMISM,
    ChainId.BSC,
    ChainId.BASE,
    ChainId.ARBITRUM
  ],
  defaultChainId: ChainId.OPTIMISM,
  kulapPlusApiBaseUrl: 'https://beta-plus-api.kulap.io/api/v1',
  kulapPlusUtilityFileUrl:
    'https://kulap-plus-utility-file-beta.s3.ap-southeast-1.amazonaws.com',
  kulapPlusTokenListFilePath: {
    [ChainId.ETHEREUM]: '/token-lists/ethereum.json',
    [ChainId.OPTIMISM]: '/token-lists/optimism.json',
    [ChainId.BSC]: '/token-lists/bsc.json',
    [ChainId.BASE]: '/token-lists/base.json',
    [ChainId.ARBITRUM]: '/token-lists/arbitrum.json'
  },
  kulapSwapFrontendUrl: 'http://alpha.kulap.io',
  kulapPlusFrontendUrl: 'https://beta-app.kulap.io',
  googleRecaptcha: '6Ld_pMUZAAAAAM5Pajn7kxKwQRbJGoqIRb3axu7Y',
  facebookAppId: '2228084830653503',
  initFromFiatCurrencyAmount: '17',
  checkUserEligibilityTrade: false,
  depositSwapContractAddresses: {
    [ChainId.ETHEREUM]: '0x8064D91Bf2cdf289206D5B22488DC4Cd9c8cBbe0',
    [ChainId.BSC]: '0xf8eDbcad017cDbe8d5670729727a6837C3aC3aD7',
    [ChainId.OPTIMISM]: '0x607F0fC98578F93589083f0F1bAc293b01bb8068',
    [ChainId.BASE]: '0x4128c861D87781D7EC7AE9Ad87e79cE4a54c1c13',
    [ChainId.ARBITRUM]: '0x4128c861D87781D7EC7AE9Ad87e79cE4a54c1c13'
  },
  thaiD: {
    apiEndpoint: 'https://imauth.bora.dopa.go.th/api/v2',
    clientId: 'bDNWUDBJYVNJVE4xNDhPRUhsTDdZSXNRM0RLZzl6WE4',
    redirectUri:
      'https://beta-plus-api.kulap.io/api/v1/kyc-provider/thaid/callback'
  }
}
